<template>
  <div>
    <el-button
      :size="size || 'mini'"
      :class="[btnCLass ? btnCLass : null, 'btn']"
      :type="type ? type : 'info'"
      :disabled="disabled"
      @click="clickBtn"
      >{{ msg }}</el-button
    >
  </div>
</template>

<script>
export default {
  props: ["type", "btnCLass", "cutTime", "sendFn", "size"],
  name: "msgBtnComponent",
  data() {
    return {
      time: 10,
      msg: "验证码",
      disabled: false,
    };
  },
  mounted() {},
  methods: {
    clickBtn() {
      if (this.sendFn) {

        this.sendFn()
          .then((data) => {
            this.cutDown(data);
          })
          .catch((err) => {
      
            this.$alert(JSON.stringify(err));
          });
      } else {
        this.$alert("sendFn函数未传，注意函数须是promise");
      }
    },
    cutDown(data) {
      this.$emit("success", data);
 
      this.time = this.cutTime || 10;
      this.disabled = true;
      this.msg = this.time + "s";
      this.timer = setInterval(() => {
        if (this.time <= 0) {
          clearInterval(this.timer);
          this.msg = "验证码";
          this.disabled = false;
        } else {
          this.disabled = true;
          let current = this.time - 1;
          this.time = current;
          this.msg = current + "s";
        }
      }, 1000);
    },
  },
};
</script>

<style scoped lang='less'>
.btn {
  border-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/components/MsgBtn/MsgBtnComponent.vue